// function ageVerification() {
//   $("#js--age-verification-save").click(function () {
//     $(this).addClass("avc--yes");

//     gsap.to("#js--age-verification-checked", {
//       opacity: 1,
//       scale: 1,
//       rotate: 0,
//       duration: 0.5,
//       delay: 0.2,

//       ease: CustomBounce.create("myBounce", {
//         strength: 2,
//         endAtStart: false,
//         squash: 0,
//         squashID: "myBounce-squash",
//       }),
//     });
//   });

//   $("#js--av-no").click(function () {
//     window.location.href = "https://www.google.com";
//   });

//   $("#js--av-yes").click(function () {
//     $("body").removeClass("age_verification_false");
//     $("html").removeClass("age_verification_false");

//     gsap.to(".age_verification__modal", {
//       opacity: 0,
//     });
//     gsap.to(".age_verification__container", {
//       opacity: 0,
//       rotate: 380,
//       left: 3000,
//     });

//     $(".age_verification__modal").remove();
//     $(".age_verification__container").remove();

//     const days = 365 * 10; // 10 years
//     const d = new Date();
//     d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
//     const expires = "expires=" + d.toUTCString();
//     document.cookie = "age-verification-yes=true; " + expires + "; path=/; Secure; SameSite=Lax";
//   });
// }

// export function setupAgeVerification() {
//   function getCookie(name) {
//     const value = `; ${document.cookie}`;
//     const parts = value.split(`; ${name}=`);
//     if (parts.length === 2) return parts.pop().split(";").shift();
//   }

//   // Example: check and perform a function
//   // if (getCookie("age-verification-yes") === "true") {
//   //   $("body").removeClass("age_verification_false");
//   //   $("html").removeClass("age_verification_false");

//   //   gsap.to(".age_verification__modal", {
//   //     opacity: 0,
//   //   });
//   //   $(".age_verification__modal").remove();
//   //   $(".age_verification__container").remove();
//   // } else {
//   gsap.to(".age_verification__container", {
//     opacity: 1,
//   });
//   ageVerification();
//   // }
// }

// // working code with original script.js

// function setSessionCookie(name, value) {
//   // Session cookie: no expires/max-age → cleared when browser closes
//   document.cookie = `${name}=${value}; path=/; SameSite=Lax;` + (location.protocol === "https:" ? " Secure;" : "");
// }

// function getCookie(name) {
//   const value = `; ${document.cookie}`;
//   const parts = value.split(`; ${name}=`);
//   if (parts.length === 2) return parts.pop().split(";").shift();
//   return undefined;
// }

// function ageVerification() {
//   $("#js--age-verification-save").on("click", function () {
//     $(this).addClass("avc--yes");

//     gsap.to("#js--age-verification-checked", {
//       opacity: 1,
//       scale: 1,
//       rotate: 0,
//       duration: 0.5,
//       delay: 0.2,
//       ease: CustomBounce.create("myBounce", {
//         strength: 2,
//         endAtStart: false,
//         squash: 0,
//         squashID: "myBounce-squash",
//       }),
//     });
//   });

//   $("#js--av-no").on("click", function () {
//     window.location.href = "https://www.google.com";
//   });

//   $("#js--av-yes").on("click", function () {
//     // set the session cookie first
//     setSessionCookie("age-verification-yes", "true");

//     // unblock page styles immediately
//     $("body, html").removeClass("age_verification_false");

//     // fade out and remove modal
//     gsap.to(".age_verification__modal", { opacity: 0, duration: 0.2 });
//     gsap.to(".age_verification__container", {
//       opacity: 0,
//       rotate: 380,
//       left: 3000,
//       duration: 0.3,
//       onComplete: () => {
//         $(".age_verification__modal, .age_verification__container").remove();
//       },
//     });
//   });
// }

// export function setupAgeVerification() {
//   // If already verified in this session, remove modal immediately and bail
//   if (getCookie("age-verification-yes") === "true") {
//     $("body, html").removeClass("age_verification_false");
//     $(".age_verification__modal, .age_verification__container").remove();
//     return;
//   }

//   // Otherwise show modal and wire up handlers
//   gsap.to(".age_verification__container", { opacity: 1, duration: 0.2 });
//   ageVerification();
// }

// // test for faster page load

// // components/ageVerification.js

// function setSessionCookie(name, value) {
//   document.cookie = `${name}=${value}; path=/; SameSite=Lax;` + (location.protocol === "https:" ? " Secure;" : "");
// }

// function getCookie(name) {
//   const value = `; ${document.cookie}`;
//   const parts = value.split(`; ${name}=`);
//   if (parts.length === 2) return parts.pop().split(";").shift();
//   return undefined;
// }

// function ageVerification() {
//   $("#js--age-verification-save").on("click", function () {
//     $(this).addClass("avc--yes");

//     gsap.to("#js--age-verification-checked", {
//       opacity: 1,
//       scale: 1,
//       rotate: 0,
//       duration: 0.5,
//       delay: 0.2,
//       ease: CustomBounce.create("myBounce", {
//         strength: 2,
//         endAtStart: false,
//         squash: 0,
//         squashID: "myBounce-squash",
//       }),
//     });
//   });

//   $("#js--av-no").on("click", function () {
//     window.location.href = "https://www.google.com";
//   });

//   $("#js--av-yes").on("click", function () {
//     setSessionCookie("age-verification-yes", "true");
//     $("body, html").removeClass("age_verification_false");

//     gsap.to(".age_verification__modal", { opacity: 0, duration: 0.2 });
//     gsap.to(".age_verification__container", {
//       opacity: 0,
//       rotate: 380,
//       left: 3000,
//       duration: 0.3,
//       onComplete: () => {
//         $(".age_verification__modal, .age_verification__container").remove();
//       },
//     });
//   });
// }

// export function setupAgeVerification() {
//   // If already verified in this session, remove modal immediately and bail
//   if (getCookie("age-verification-yes") === "true") {
//     $("body, html").removeClass("age_verification_false");
//     $(".age_verification__modal, .age_verification__container").remove();

//     // also fire "show" so preload still starts even if modal isn't displayed
//     window.dispatchEvent(new CustomEvent("ageVerification:show"));
//     return;
//   }

//   // Otherwise show modal and wire up handlers
//   gsap.to(".age_verification__container", { opacity: 1, duration: 0.2 });

//   // 👉 tell the app the modal is now visible so it can start preloading
//   window.dispatchEvent(new CustomEvent("ageVerification:show"));

//   ageVerification();
// }

function unlockVideos(selector = "video") {
  // console.log("running video unlock");
  document.querySelectorAll(selector).forEach((v) => {
    try {
      v.muted = true;
      v.playsInline = true;
      v.setAttribute("playsinline", "");
      v.setAttribute("webkit-playsinline", "");
      v.play?.()
        .then(() => {
          v.pause?.();
          try {
            v.currentTime = 0;
          } catch {}
        })
        .catch(() => {});
    } catch {}
  });
}

function setSessionCookie(name, value) {
  document.cookie = `${name}=${value}; path=/; SameSite=Lax;` + (location.protocol === "https:" ? " Secure;" : "");
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return undefined;
}

function wireAgeHandlers(onAccept) {
  // “Yes” tick animation
  $("#js--age-verification-save").on("click", function () {
    $(this).addClass("avc--yes");
    gsap.to("#js--age-verification-checked", {
      opacity: 1,
      scale: 1,
      rotate: 0,
      duration: 0.5,
      delay: 0.2,
      ease: CustomBounce.create("myBounce", {
        strength: 2,
        endAtStart: false,
        squash: 0,
        squashID: "myBounce-squash",
      }),
    });
  });

  // “No”
  $("#js--av-no").one("click", () => {
    window.location.href = "https://www.google.com";
  });

  // “Yes”
  $("#js--av-yes").one("click", () => {
    // 1) mark this session
    setSessionCookie("age-verification-yes", "true");

    // 2) immediately unblock styles
    $("body, html").removeClass("age_verification_false");

    // 3) animate out & remove modal
    gsap.to(".age_verification__modal", { opacity: 0, duration: 0.2 });
    gsap.to(".age_verification__container", {
      opacity: 0,
      rotate: 380,
      left: 3000,
      duration: 0.3,
      onComplete: () => {
        $(".age_verification__modal, .age_verification__container").remove();
      },
    });

    // 4) **Use this gesture to unlock autoplay on iOS**
    //    Keep videos muted/inline and prime a frame so they won’t disappear.
    unlockVideos();

    // 👇 add this so the cookie consent knows it can show now
    document.dispatchEvent(new CustomEvent("age:verified"));

    // 5) notify app & optional hook
    window.dispatchEvent(new CustomEvent("ageVerification:accept"));
    if (typeof onAccept === "function") onAccept();
  });
}

export function setupAgeVerification(hooks = {}) {
  const { onShow, onAccept } = hooks;

  // Already verified this session → remove modal and proceed
  if (getCookie("age-verification-yes") === "true") {
    $("body, html").removeClass("age_verification_false");
    $(".age_verification__modal, .age_verification__container").remove();

    // We still tell the app “shown” so it can keep its boot flow consistent
    // (Note: calling unlockVideos() here usually won’t work on iOS without a fresh gesture,
    //  so we *don’t* attempt it automatically.)
    window.dispatchEvent(new CustomEvent("ageVerification:show"));
    if (typeof onShow === "function") onShow();
    return;
  }

  // Show modal
  gsap.to(".age_verification__container", { opacity: 1, duration: 0.2 });

  // Let the app know the gate is visible (good time for light preloads)
  window.dispatchEvent(new CustomEvent("ageVerification:show"));
  if (typeof onShow === "function") onShow();

  // Wire buttons (includes unlockVideos() on Yes)
  wireAgeHandlers(onAccept);

  $(function () {
    const $box = $(".age_verification__checkbox");
    if (!$box.length) return;

    const setCookie = (n, v, d) => {
      const maxAge = d ? d * 24 * 60 * 60 : 0;
      const secure = location.protocol === "https:" ? "; Secure" : "";
      document.cookie = `${n}=${encodeURIComponent(v)}; Path=/; Max-Age=${maxAge}; SameSite=Lax${secure}`;
    };
    const getCookie = (n) =>
      document.cookie
        .split("; ")
        .find((c) => c.startsWith(n + "="))
        ?.split("=")[1];

    if (getCookie("cookiesConsent") === "yes") $box.addClass("is-checked");

    $box.on("click", function (e) {
      if ($(e.target).closest("a").length) return;
      $(this).toggleClass("is-checked");
      if ($(this).hasClass("is-checked")) {
        setCookie("cookiesConsent", "yes", 365);
      } else setCookie("cookiesConsent", "", -1);
    });
  });
}
